var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.IsPaymentSuccessfull)?_c('a',{attrs:{"href":'/Receipt/'+_vm.row.SystemReceiptCode,"target":"_blank"}},[_vm._v(_vm._s(_vm.row.SystemReceiptCode))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }